import { ACCOUNT_ACTION } from '../../../constants/actions'
import { DEFAULT_CONTAINER_STATE } from '../../../constants/containerStates'
import { KYC_STAGE } from '../../../util/kyc.helpers'
import { mergeToNewObject } from '../../../util/object.helpers'

export const kycProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ACCOUNT_ACTION.GENERATE_KYC_SESSION:
      return mergeToNewObject(state, { id: '', isProcessing: true })

    case ACCOUNT_ACTION.GENERATE_KYC_SESSION_SUCCESS:
      return mergeToNewObject(state, handleKycResponse(payload), {
        isProcessing: false
      })

    case ACCOUNT_ACTION.REFRESH_KYC:
      return mergeToNewObject(state, {
        isRefreshing: true
      })

    case ACCOUNT_ACTION.REFRESH_KYC_SUCCESS:
      return mergeToNewObject(state, handleKycResponse(payload), {
        isRefreshing: false
      })

    case ACCOUNT_ACTION.REFRESH_KYC_FAILED:
      return mergeToNewObject(state, {
        isRefreshing: false
      })

    case ACCOUNT_ACTION.GET_ACCOUNT_DETAILS_SUCCESS:
      return mergeToNewObject(state, handleKycResponse(payload))

    case ACCOUNT_ACTION.GENERATE_KYC_SESSION_FAILED:
      return mergeToNewObject(state, {
        id: '',
        isProcessing: false,
        status: KYC_STAGE.FAILED
      })

    case ACCOUNT_ACTION.CHANGE_KYC_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    default:
      return state
  }
}

const INITIAL_STATE = {
  popupState: { id: DEFAULT_CONTAINER_STATE.NONE, data: null },
  id: '',
  status: KYC_STAGE.NULL,
  error: {},
  isRefreshing: false,
  isProcessing: false
}

export const KYC_PROFILE_DISPATCH = {
  ERROR: 'error',
  POPUP_STATE: 'popupState'
}

const handleKycResponse = ({ kycId, kycStage }) => {
  return {
    id: kycId,
    status: kycStage,
    isProcessing: false
  }
}
